// extracted by mini-css-extract-plugin
export default {"single-tab":"headerTab_single-tab__dwXj4"};